import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { AuthService } from 'src/app/auth/AuthService';
import { NavigationEnd, Router } from '@angular/router';
import { filter, distinctUntilChanged, first, takeUntil, finalize } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ClientService } from '../../Services/client.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../Services/UserService';
import swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';
import { AuthGuard } from '../../auth/Auth-guard';
import { StatsService } from '../../Services/stats.service';
import { ClientIdBusService } from '../../Services/client-id-bus.service';
import { Subscription } from 'rxjs';
import {  NotificationWebsocketService } from '../../Services/notification-websocket.service';
import {  NotificationResponse } from '../../Model/notification-response';

export interface NotificationPageResponse {
  content: NotificationResponse[];
  number: number;
  size: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit, OnDestroy {
  pageTitle: string = 'CEC PMS';
  submenuOpen: boolean = false;

  title: string = 'PMS';
  searchText: string = '';
  isScrolled = false;
  errorMessage: string = '';
  isLoggedIn: boolean = false;

  clientList: any[] = [];
  resetPasswordForm!: FormGroup;
  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  roles: string[] = [];
  cIdForm!: FormGroup;
  clientId: any;
  isModalOpen: boolean = false;
  public clientListLoaded = false;
  public clientListLoading = false;
  selectedClientName: string | null = null;
  selectedClient: number | null = null;
  private pendingClientId: number | null = null;
  userName: string = 'CID';
  stats: any = {};
  activeDropdown: string = '';
  isDarkMode = false;
  welcomeVisible: boolean = false;
  sidebarCollapsed = false;
  reportingMenuOpen = false;
  workflowMenuOpen = false;
  workflowWorkOrderOpen = false;
  repositoryMenuOpen = false;
  auditMenuOpen = false;
  mailMenuOpen = false;
  adminMenuOpen = false;
  extractorMenuOpen = false;
  showClientModal = false;
  showResetPasswordModal = false;
  showUserProfileModal = false;
  isMobileView = window.innerWidth < 992;
  collapseTimer: any;

  private destroy$ = new Subject<void>();
  private loginInitInProgress = false;
  private hasLoadedClientList = false;
  // private loginSubscription: Subscription;

  notifications: NotificationResponse[] = [];
  notificationPopups: NotificationResponse[] = [];
  private notificationPopupTimers =
  new Map<number, ReturnType<typeof setTimeout>>();
  unreadNotificationCount = 0;
  notificationDropdownOpen = false;
  notificationHistoryLoading = false;
  markAllNotificationsLoading = false;
  notificationPage = 0;
  notificationPageSize = 20;

  notificationHistoryInitialized = false;
  notificationHistoryLastPage = false;

  trackByClientId(index: number, item: any) {
    return item.id;
  }

  compareClientId = (a: any, b: any) => Number(a) === Number(b);

  userProfileForm!: FormGroup;
  profileImage: string | ArrayBuffer | null = null;

  private routeDropdownMap: { [key: string]: string } = {
    '/home': 'home',
    '/report': 'reporting',
    '/hmoRegistration': 'workflow',
    '/patient': 'workflow',
    '/userworkarea': 'workflow',
    '/repository': 'repository',
    '/extractor': 'extractor',
    '/pasting': 'extractor',
    '/emailAutomation': 'extractor',
    '/extractorReport': 'extractor',
    '/provider': 'admin',
    '/client': 'admin',
    '/office': 'admin',
    '/user': 'admin',
    '/rules': 'admin',
    '/questions': 'admin',
    '/payer': 'admin',
    '/audit/severity-configuration': 'admin',
    '/audit/error-configuration': 'admin'
  };

  // @ViewChild('resetPassword') resetPassModal!: ElementRef;
  @ViewChild('CId') cIdModal!: ElementRef;
  /*@ViewChild('userProfile') userProfileModal!: ElementRef;*/

  constructor(
    public authService: AuthService,
    private clientServices: ClientService,
    private userService: UserService,
    private el: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private router: Router,
    private authGuard: AuthGuard,
    private ngZone: NgZone,
    private statsService: StatsService,
    private clientIdBus: ClientIdBusService,
    private cdr: ChangeDetectorRef,
    private notificationWebSocketService: NotificationWebsocketService,
  ) {
    this.resetPasswordForm = this.fb.group(
      {
        userName: [null, [Validators.required]],
        currentPassword: [
          null,
          [
            Validators.required,
            Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')
          ]
        ],
        newPassword: [
          null,
          [
            Validators.required,
            Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')
          ]
        ],
        confirmPassword: [
          null,
          [
            Validators.required,
            Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')
          ]
        ]
      },
      { validators: this.passwordsMatch }
    );

    this.cIdForm = this.fb.group({
      clientId: [
        sessionStorage.getItem('clientId')
          ? Number(JSON.parse(sessionStorage.getItem('clientId') as string))
          : null,
        Validators.required
      ]
    });

    this.userProfileForm = this.fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      role: [null, [Validators.required]],
      designation: [null]
    });

    // this.authService.loginChanged
    //   .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
    //   .subscribe(async (loggedIn) => {
    //     this.isLoggedIn = loggedIn;

    //     if (loggedIn) {
    //       await this.handleLoginSuccess();
    //     } else {
    //       this.resetClientState();
    //     }

    //     this.cdr.markForCheck();
    //   });
  }

async ngOnInit(): Promise<void> {

  this.startAutoSidebarToggle();

  this.isMobileView =
    window.innerWidth < 992;

  /*
   * FIRST:
   * Navbar starts listening for notification
   * updates/popups/count changes.
   */
  this.initializeNotificationState();

  /*
   * THEN:
   * initialize WebSocket service.
   */
  this.notificationWebSocketService
    .initialize();

  /*
   * THEN:
   * initialize existing authentication/navbar state.
   */
  await this.initializeAuthenticationState();

  this.statsService.stats$
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe(data => {

      if (data) {
        this.stats = data;

        this.cdr.markForCheck();
      }
    });

  const savedTheme =
    localStorage.getItem('theme');

  this.isDarkMode =
    savedTheme === 'dark';

  this.applyTheme();

  this.setActiveDropdownFromRoute(
    this.router.url
  );

  this.router.events
    .pipe(
      filter(
        event =>
          event instanceof NavigationEnd
      ),
      takeUntil(this.destroy$)
    )
    .subscribe(
      (event: NavigationEnd) => {

        this.setActiveDropdownFromRoute(
          event.url
        );

        this.cdr.markForCheck();
      }
    );

  this.authService.clientId$
    .pipe(
      filter(
        (id: any) =>
          id != null
      ),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
    .subscribe(
      (id: any) => {

        this.pendingClientId =
          Number(id);

        this.applySelection();

        this.cdr.markForCheck();
      }
    );

  if (
    this.authService.isExternalUser()
  ) {
    this.showExternalWelcomeSplash();
  }

  this.notificationWebSocketService
    .errors$
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe(
      (message: string) => {
        console.error(message);
      }
    );

  /*
   * Initial persisted notification history.
   */
  this.fetchNotificationHistory(true);
}


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.collapseTimer) {
      clearTimeout(this.collapseTimer);
    }

    //  if (this.loginSubscription) {
    //   this.loginSubscription.unsubscribe();
    // }

    this.notificationPopupTimers.forEach(
      timer => clearTimeout(timer)
    );

    this.notificationPopupTimers.clear();
  }

  private async initializeAuthenticationState():
  Promise<void> {

  const loggedIn =
    await this.authService.isLoggedIn();

  this.isLoggedIn = loggedIn;

  if (loggedIn) {
    await this.getUserNameFromToken();
    await this.handleLoginSuccess();

    if (
      this.authService.isExternalUser()
    ) {
      this.showExternalWelcomeSplash();
    }
  }

  this.authService.loginChanged
    .pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    )
    .subscribe(
      async (loginState: boolean) => {
        this.isLoggedIn = loginState;

        if (loginState) {
          await this.getUserNameFromToken();
          await this.handleLoginSuccess();

          if (
            this.authService.isExternalUser()
          ) {
            this.showExternalWelcomeSplash();
          }
        } else {
          this.userName = 'CID';
          this.resetClientState();
        }

        this.cdr.markForCheck();
      }
    );
}

  startAutoSidebarToggle(): void {
    if (this.collapseTimer) {
      clearTimeout(this.collapseTimer);
    }

    this.collapseTimer = setTimeout(() => {
      this.sidebarCollapsed = true;
      this.cdr.markForCheck();
    }, 20000); // 10 seconds
  }

  private async handleLoginSuccess() {
    if (this.loginInitInProgress) {
      return;
    }

    this.loginInitInProgress = true;

    try {
      const token = await this.authService.getAccessToken();
      if (!token) {
        this.loginInitInProgress = false;
        return;
      }

      const decodedToken: any = jwtDecode(token);
      const existingClientId =
        this.authService.clientId ||
        (sessionStorage.getItem('clientId')
          ? Number(JSON.parse(sessionStorage.getItem('clientId') as string))
          : null);

      if (existingClientId) {
        this.pendingClientId = Number(existingClientId);
      }

      if (decodedToken.userType === 'INTERNAL' && !this.hasLoadedClientList) {
        this.loadClientListAndShowModal();
      }

      if (decodedToken.userType === 'EXTERNAL') {
        if (!this.hasLoadedClientList) {
          this.getClientList();
        }

        const externalClientId = Number(decodedToken?.client_id);
        if (externalClientId) {
          this.cIdForm.patchValue(
            {
              clientId: externalClientId
            },
            { emitEvent: false }
          );

          this.selectedClient = externalClientId;
          this.pendingClientId = externalClientId;

          if (!this.authService.clientId) {
            this.authService.setClientId(externalClientId);
            sessionStorage.setItem('clientId', JSON.stringify(externalClientId));
          }
        }
      }

      console.log(
        '[Navbar] initializing notification WebSocket'
      );
      this.notificationWebSocketService.initialize();
    } catch (error) {
      console.error('Error handling login success:', error);
    } finally {
      this.loginInitInProgress = false;
      this.cdr.markForCheck();
    }
  }

  private initializeNotificationState(): void {
  this.notificationWebSocketService.notifications$
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (notifications: NotificationResponse[]) => {
        this.ngZone.run(() => {
          this.notifications = [
            ...notifications
          ];
          this.cdr.markForCheck();
        });
      }
    );

    this.notificationWebSocketService
      .liveNotification$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (notification: NotificationResponse) => {
          this.ngZone.run(() => {
            this.showNotificationPopup(
              notification
            );
          });
        }
      );

  this.notificationWebSocketService.unreadCount$
    .pipe(takeUntil(this.destroy$))
    .subscribe((count: number) => {
      this.ngZone.run(() => {
        this.unreadNotificationCount = count;
        this.cdr.markForCheck();
      });
    });
  }
  private fetchNotificationHistory(
    reset: boolean = false
  ): void {
    if (
      this.notificationHistoryLoading ||
      (!reset && this.notificationHistoryLastPage)
    ) {
      return;
    }

    if (reset) {
      this.notificationPage = 0;
      this.notificationHistoryLastPage = false;
      this.notificationHistoryInitialized = false;
    }

    this.notificationHistoryLoading = true;

    this.notificationWebSocketService
      .getMyNotifications(
        this.notificationPage,
        this.notificationPageSize
      )
      .pipe(
        first(),
        finalize(() => {
          this.ngZone.run(() => {
            this.notificationHistoryLoading = false;
            this.notificationHistoryInitialized = true;
            this.cdr.markForCheck();
          });
        })
      )
      .subscribe(
        (response: NotificationPageResponse) => {
          this.ngZone.run(() => {
            const pageNotifications =
              Array.isArray(response?.content)
                ? response.content
                : [];

            this.notificationWebSocketService
              .appendNotificationHistory(
                pageNotifications
              );

            this.notificationHistoryLastPage =
              response?.last === true ||
              pageNotifications.length <
                this.notificationPageSize;

            if (!this.notificationHistoryLastPage) {
              this.notificationPage =
                response.number + 1;
            }

            this.cdr.markForCheck();
          });
        },
        error => {
          console.error(
            '[Notifications] unable to load history:',
            error
          );
        }
      );
  }
  private showNotificationPopup(
  notification: NotificationResponse
  ): void {
    const alreadyVisible =
      this.notificationPopups.some(
        (popup: NotificationResponse) =>
          popup.id === notification.id
      );

    if (alreadyVisible) {
      return;
    }

    this.notificationPopups = [
      notification,
      ...this.notificationPopups
    ].slice(0, 3);

    this.cdr.markForCheck();

    const timer =
      setTimeout(() => {
        this.ngZone.run(() => {
          this.dismissNotificationPopup(
            notification.id
          );
        });
      }, 7000);

    this.notificationPopupTimers.set(
      notification.id,
      timer
    );
  }

  dismissNotificationPopup(
    notificationId: number,
    event?: MouseEvent
  ): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.notificationPopups =
      this.notificationPopups.filter(
        (notification: NotificationResponse) =>
          notification.id !== notificationId
      );

    const timer =
      this.notificationPopupTimers.get(
        notificationId
      );

    if (timer) {
      clearTimeout(timer);

      this.notificationPopupTimers.delete(
        notificationId
      );
    }

    this.cdr.markForCheck();
  }

  openNotificationPopup(
    notification: NotificationResponse,
    event: MouseEvent
  ): void {
    this.dismissNotificationPopup(
      notification.id
    );

    this.openNotification(
      notification,
      event
    );
  }
  
  onNotificationScroll(
  event: Event
): void {
  const element =
    event.target as HTMLElement;

  const remainingDistance =
    element.scrollHeight -
    element.scrollTop -
    element.clientHeight;

  const loadThreshold = 80;

  if (
    remainingDistance <= loadThreshold &&
    !this.notificationHistoryLoading &&
    !this.notificationHistoryLastPage
  ) {
    this.fetchNotificationHistory();
  }
  }

  private loadClientListAndShowModal() {
    if (this.clientListLoading || this.hasLoadedClientList) {
      if (this.clientListLoaded && !this.authService.clientId) {
        this.showClientModal = true;
        this.cdr.markForCheck();
      }
      return;
    }

    this.clientListLoading = true;
    this.clientListLoaded = false;
    this.showClientModal = false;
    this.cdr.markForCheck();

    const params = {
      isUserClient: true
    };

    this.clientServices.getUserClientDetails(params).pipe(first()).subscribe(
      (response: any[]) => {
        this.clientList = (response || []).map(c => ({
          ...c,
          id: Number(c.id)
        }));

        this.clientListLoaded = true;
        this.clientListLoading = false;
        this.hasLoadedClientList = true;

        const saved = sessionStorage.getItem('clientId');
        const savedId = saved ? Number(JSON.parse(saved)) : null;
        if (savedId != null) {
          this.pendingClientId = savedId;
        }

        this.applySelection();

        if (!this.authService.clientId && !savedId) {
          this.showClientModal = true;
        }

        this.cdr.markForCheck();
      },
      error => {
        console.error('Error loading client list:', error);
        this.clientListLoaded = false;
        this.clientListLoading = false;
        this.showClientModal = false;
        this.cdr.markForCheck();
      }
    );
  }

  toggleSidebar() {
    if (this.isMobileView) {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      return;
    }

    this.sidebarCollapsed = !this.sidebarCollapsed;
  }
  onWorkflowClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.workflowMenuOpen = true;
      }, 50);
      return;
    }

    this.workflowMenuOpen = !this.workflowMenuOpen;
  }

  onRepositoryClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.repositoryMenuOpen = true;
      }, 50);
      return;
    }

    this.repositoryMenuOpen = !this.repositoryMenuOpen;
  }

  onAuditClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.auditMenuOpen = true;
      }, 50);
      return;
    }

    this.auditMenuOpen = !this.auditMenuOpen;
  }

  onMailClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.mailMenuOpen = true;
      }, 50);
      return;
    }

    this.mailMenuOpen = !this.mailMenuOpen;
  }

  onExtractorClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.extractorMenuOpen = true;
      }, 50);
      return;
    }

    this.extractorMenuOpen = !this.extractorMenuOpen;
  }

  onAdminClick() {
    if (this.sidebarCollapsed) {
      this.sidebarCollapsed = false;
      setTimeout(() => {
        this.adminMenuOpen = true;
      }, 50);
      return;
    }

    this.adminMenuOpen = !this.adminMenuOpen;
  }

  getClientList() {
    if (this.clientListLoading || this.hasLoadedClientList) {
      return;
    }

    this.clientListLoading = true;
    this.clientListLoaded = false;
    this.cdr.markForCheck();

    const params = { isUserClient: true };

    this.clientServices.getClientDetails(params).pipe(first()).subscribe(
      (response: any[]) => {
        this.clientList = (response || []).map(c => ({ ...c, id: Number(c.id) }));
        this.clientListLoaded = true;
        this.clientListLoading = false;
        this.hasLoadedClientList = true;

        const saved = sessionStorage.getItem('clientId');
        const savedId = saved ? Number(JSON.parse(saved)) : null;
        if (savedId != null) {
          this.pendingClientId = savedId;
        }

        this.applySelection();
        this.cdr.markForCheck();
      },
      err => {
        console.error(err);
        this.clientListLoading = false;
        this.clientListLoaded = false;
        this.cdr.markForCheck();
      }
    );
  }

  private applySelection() {
    if (!this.clientListLoaded) return;

    const id = this.pendingClientId;
    if (id != null && this.clientList.some((c: any) => c.id === id)) {
      this.selectedClient = id;
      this.cIdForm.patchValue({ clientId: id }, { emitEvent: false });
    }
  }

  private resetClientState(): void {
    this.clientList = [];
    this.clientListLoaded = false;
    this.clientListLoading = false;
    this.hasLoadedClientList = false;
    this.selectedClient = null;
    this.pendingClientId = null;
    this.showClientModal = false;
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.isScrolled = window.scrollY > 20;
  }
  @HostListener('window:resize')
  onResize() {
    this.isMobileView = window.innerWidth < 992;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.notificationDropdownOpen) {
      this.notificationDropdownOpen = false;
      this.cdr.markForCheck();
    }
  }

  private setActiveDropdownFromRoute(url: string): void {
    const cleanUrl = url.split('?')[0].split('#')[0];
    this.activeDropdown = this.routeDropdownMap[cleanUrl] || '';
  }

  isDropdownActive(dropdownName: string): boolean {
    return this.activeDropdown === dropdownName;
  }

  async getUserNameFromToken() {
    try {
      let token: string | null = null;

      for (let i = 0; i < 10; i++) {
        token = await this.authService.getAccessToken();
        if (token) break;
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      if (token) {
        const decodedToken: any = jwtDecode(token);
        this.userName = decodedToken.name || 'CID';
        this.cdr.markForCheck();
        // console.log(this.userName);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    this.applyTheme();
    localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
  }

  private applyTheme(): void {
    const body = document.body;
    const root = document.documentElement;

    if (this.isDarkMode) {
      body.classList.add('bg-dark', 'dark-theme');
      body.classList.remove('bg-light');
      root.classList.add('dark-theme');
      root.style.setProperty('color-scheme', 'dark');
    } else {
      body.classList.add('bg-light');
      body.classList.remove('bg-dark', 'dark-theme');
      root.classList.remove('dark-theme');
      root.style.setProperty('color-scheme', 'light');
    }
  }

  onClientChange(id: any) {
    const clientId = Number(id);
    if (!clientId) return;

    const currentClientId = this.authService.getClientId();
    if (currentClientId === clientId) return;

    this.selectedClient = clientId;

    sessionStorage.setItem('clientId', JSON.stringify(clientId));
    this.authService.setClientId(clientId);

    sessionStorage.removeItem('lastUsedFilterParams');
    sessionStorage.removeItem('patientFilters');
    sessionStorage.removeItem('patientDuplicateFilters');

    this.clientIdBus.announce(String(clientId));
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {}

  openModali(): void {
    if (!this.cIdModal) {
      console.error('Modal element is undefined.');
      return;
    }

    this.renderer.addClass(document.body, 'blur-background');
    const modalElement = this.cIdModal.nativeElement;
    modalElement.style.display = 'flex';
  }

  closeModali(): void {
    if (!this.cIdModal) return;

    this.cIdForm.reset();
    this.renderer.removeClass(document.body, 'blur-background');
    const modalElement = this.cIdModal.nativeElement;
    modalElement.style.display = 'none';
    this.showClientModal = false;
    this.cdr.markForCheck();
  }

  closeModalAndLogout(): void {
  this.closeModali();
  this.notificationWebSocketService.disconnect();
  this.authService.logout();
  }

  onSubmitC() {
    if (this.cIdForm.valid) {
      this.cIdForm.markAllAsTouched();
      const selectedClientId = Number(this.cIdForm.controls.clientId.value);

      if (selectedClientId) {
        this.selectedClient = selectedClientId;
        this.authService.setClientId(selectedClientId);
        sessionStorage.setItem('clientId', JSON.stringify(selectedClientId));

        this.clientIdBus.announce(String(selectedClientId));
        this.closeModali();

        this.showWelcomeSplash();
      }
    }
  }

  private showWelcomeSplash(): void {
  this.welcomeVisible = true;
  this.cdr.markForCheck();

  setTimeout(() => {
    this.welcomeVisible = false;
    this.cdr.markForCheck();
  }, 3000);
  }

  private showExternalWelcomeSplash(): void {
  const splashShown =
    sessionStorage.getItem('externalWelcomeSplashShown');

  if (splashShown === 'true') {
    return;
  }

  sessionStorage.setItem(
    'externalWelcomeSplashShown',
    'true'
  );

  this.showWelcomeSplash();
  }

  selectClient(client: { id: string; name: string }): void {
    this.selectedClientName = client.name;
    this.selectedClient = Number(client.id);
    this.cIdForm.patchValue({ clientId: Number(client.id) });
  }

  passwordsMatch(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  onSubmit() {
    this.resetPasswordForm.markAllAsTouched();
    if (this.resetPasswordForm.valid) {
      let reqData = {
        userName: this.resetPasswordForm.controls.userName.value,
        currentPassword: this.resetPasswordForm.controls.currentPassword.value,
        newPassword: this.resetPasswordForm.controls.newPassword.value
      };

      this.userService.resetPassword(reqData).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.closeModal();
            swal.fire({
              icon: 'success',
              text: 'Password updated successfully.',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }
  }

  openModal() {
    this.resetPasswordForm.reset();
    // const modalElement = this.resetPassModal.nativeElement;
    // modalElement.style.display = 'flex';
    // modalElement.classList.add('show');
    this.renderer.addClass(document.body, 'blur-background');
    this.showResetPasswordModal = true;
  }

  closeModal() {
    this.resetPasswordForm.reset();
    // const modalElement = this.resetPassModal.nativeElement;
    // modalElement.style.display = 'none';
    // modalElement.classList.remove('show');
    this.renderer.removeClass(document.body, 'blur-background');
    this.showResetPasswordModal = false;
  }

  onToggleSubmenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.submenuOpen = !this.submenuOpen;
  }

  togglePasswordVisibility(num: any) {
    if (num == 1) {
      this.hidePassword = !this.hidePassword;
    }
    if (num == 2) {
      this.hideNewPassword = !this.hideNewPassword;
    }
    if (num == 3) {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.welcomeVisible = false;
    sessionStorage.removeItem('clientId');
    this.notificationWebSocketService.disconnect();
    this.authService.logout();
    this.resetClientState();
    this.cdr.markForCheck();
    sessionStorage.removeItem('externalWelcomeSplashShown');
  }

  onImageError(event: Event): void {
  const img = event.target as HTMLImageElement;
  img.src = 'assets/img/default-user.png';
  }

  openProfile() {
    this.userProfileForm.reset();
    // const modalElement = this.userProfileModal.nativeElement;
    // modalElement.style.display = 'flex';
    // modalElement.classList.add('show');
    this.renderer.addClass(document.body, 'blur-background');
    this.showUserProfileModal = true;
  }

  closeProfile() {
    this.userProfileForm.reset();
    this.profileImage = null;
    // const modalElement = this.userProfileModal.nativeElement;
    // modalElement.style.display = 'none';
    // modalElement.classList.remove('show');
    this.renderer.removeClass(document.body, 'blur-background');
    this.showUserProfileModal = false;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.profileImage = reader.result;
        this.cdr.markForCheck();
      };
      reader.readAsDataURL(file);
    }
  }

  onSubmitUserProfile() {
    if (this.userProfileForm.valid) {
      alert('Profile Updated Successfully!');
    }
  }

  toggleNotificationDropdown(
  event: MouseEvent
): void {
  event.preventDefault();
  event.stopPropagation();

  this.notificationDropdownOpen =
    !this.notificationDropdownOpen;
  }

  closeNotificationDropdown(): void {
    this.notificationDropdownOpen = false;
  }

  async openNotification(
  notification: NotificationResponse,
  event: MouseEvent
): Promise<void> {
  event.preventDefault();
  event.stopPropagation();

  this.notificationWebSocketService.markAsRead(
    notification.id
  );

  this.notificationDropdownOpen = false;

  if (!notification.patientId) {
    return;
  }

  const token =
    await this.authService.getAccessToken();

  const groups =
    this.getGroupsFromToken(token);

  const patientId = notification.patientId;

  if (groups.includes('team-member')) {
    await this.router.navigate([
      '/userworkarea/details',
      patientId
    ]);

    return;
  }

  const patientDetailsGroups = [
    'admin',
    'auditor',
    'supervisor',
    'provider'
  ];

  const canOpenPatientDetails =
    groups.some((group: string) =>
      patientDetailsGroups.includes(group)
    );

  if (canOpenPatientDetails) {
    await this.router.navigate([
      '/patient/details',
      patientId
    ]);

    return;
  }

  console.warn(
    '[Notifications] no notification route configured for groups:',
    groups
  );
  }
  private getGroupsFromToken(
  token: string | null
): string[] {
  if (!token) {
    return [];
  }

  try {
    const payloadPart = token.split('.')[1];

    if (!payloadPart) {
      return [];
    }

    const normalizedPayload =
      payloadPart
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const paddedPayload =
      normalizedPayload.padEnd(
        Math.ceil(normalizedPayload.length / 4) * 4,
        '='
      );

    const payload =
      JSON.parse(atob(paddedPayload));

    const groupClaim =
      payload.group || payload.groups || [];

    const groups =
      Array.isArray(groupClaim)
        ? groupClaim
        : [groupClaim];

    return groups
      .filter((group: any) => !!group)
      .map((group: any) =>
        String(group)
          .replace(/^\/+/, '')
          .trim()
          .toLowerCase()
      );
  } catch (error) {
    console.error(
      '[Notifications] unable to read JWT groups:',
      error
    );

    return [];
  }
  }
  // markAllNotificationsAsRead(
  //   event: MouseEvent
  // ): void {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   this.notificationWebSocketService.markAllAsRead();
  // }

  markAllNotificationsAsRead(
  event: MouseEvent
): void {
  event.preventDefault();
  event.stopPropagation();

  if (
    this.markAllNotificationsLoading ||
    this.unreadNotificationCount === 0
  ) {
    return;
  }

  this.markAllNotificationsLoading = true;

  this.notificationWebSocketService
    .markAllAsReadOnServer()
    .pipe(
      first(),
      finalize(() => {
        this.markAllNotificationsLoading = false;
        this.cdr.markForCheck();
      })
    )
    .subscribe(
      () => {
        this.ngZone.run(() => {
          this.notificationWebSocketService
            .markAllAsRead();

          this.cdr.markForCheck();
        });
      },
      error => {
        console.error(
          '[Notifications] unable to mark all as read:',
          error
        );
      }
    );
  }

  trackByNotificationId(
    index: number,
    notification: NotificationResponse
  ): number {
    return notification.id;
  }

  getNotificationIcon(
    notificationType: string
  ): string {
    switch (notificationType) {
      case 'PATIENT_CREATED':
        return 'fas fa-user-plus';

      case 'PATIENT_ASSIGNED':
        return 'fas fa-user-check';

      case 'PATIENT_VERIFIED':
        return 'fas fa-check-circle';

      default:
        return 'fas fa-bell';
    }
  }
}
